







import VueOptions from '@utils/VueOptions'
# import RecapsHeroDashboardView from '@ui/Dashboard/Views/Organizer/RecapsHero/RecapsHeroDashboardView'
import RecapList from '@hostComponents/Recap/RecapList'

settings =
  name: 'RecapListPage'

  components: {
    RecapList,
    # RecapsHeroDashboardView,
  }

export default VueOptions.vue settings
